import React, { useState, useEffect, useRef } from 'react';
import { Search, X } from 'lucide-react';

interface SearchBarProps {
  onSearch: (query: string) => void;
  placeholder?: string;
  initialValue?: string;
  className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  placeholder = "検索...",
  initialValue = "",
  className = ""
}) => {
  const [query, setQuery] = useState(initialValue);
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  // 初期値が変更された場合にクエリを更新
  useEffect(() => {
    setQuery(initialValue);
  }, [initialValue]);

  // 検索処理
  const handleSearch = (searchQuery: string) => {
    setQuery(searchQuery);
    onSearch(searchQuery);
  };

  // エンターキーで検索
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch(query);
    }
  };

  // 検索クリア
  const clearSearch = () => {
    handleSearch("");
    setQuery("");
    inputRef.current?.focus();
  };

  return (
    <div className={`relative ${className}`}>
      <div className={`
        flex items-center transition-colors duration-300 rounded-none border
        ${isFocused
          ? 'bg-white/10 border-white/30'
          : 'bg-black/20 border-white/10 hover:bg-black/30 hover:border-white/20'
        }
      `}>
        <Search className="absolute left-3 w-4 h-4 text-white/50" />
        <input
          ref={inputRef}
          type="text"
          value={query}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setQuery(e.target.value)}
          onKeyPress={handleKeyPress}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          className="w-full pl-10 pr-10 py-2 bg-transparent text-white placeholder-white/50 focus:outline-none"
          aria-label="検索"
        />
        {query && (
          <button
            onClick={clearSearch}
            className="absolute right-3 p-1 text-white/50 hover:text-white transition-colors duration-300"
            aria-label="検索をクリア"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;